import React, { Component } from "react";
import * as HMS from "../../../../common/component/Index";
import * as Func from "../../../../../../helpers/functions";
import Wrapper from "../../../../common/component/Wrapper";
import { Checkbox, Divider, Input, InputNumber } from "antd";
import PackageRateConfigTime from "./components/PackageRateConfigTime";
import {
  PACKAGE_RATE_OBJECT,
  PACKAGE_RATE_CHANNEL,
  RATECODE,
  PACKAGE_RATE_DISPLAY_SALE_TYPE,
} from "../../../../../../constants/Define";
import { toArray } from "lodash";

const CheckboxGroup = Checkbox.Group;

export default class PackageRateInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getPlatformAll = () => {
    return toArray(PACKAGE_RATE_CHANNEL.ALL);
  };

  getPlatformOther = () => {
    return toArray(PACKAGE_RATE_CHANNEL.OTHER);
  };

  getObjectAll = () => {
    return toArray(PACKAGE_RATE_OBJECT.ALL);
  };

  getObjectOther = () => {
    return toArray(PACKAGE_RATE_OBJECT.OTHER);
  };

  getDisplayType = () => {
    return toArray(PACKAGE_RATE_DISPLAY_SALE_TYPE);
  };

  render() {
    const { t, validation, PackageRate, disabled } = this.props;

    return (
      <div className="basic-info">
        <div className="basic-info-box">
          <div className="row">
            <div className="col-md-6">
                <HMS.FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={PackageRate.code}
                  validation={validation.code}
                  labelTitle={t(`item.packageRate.code`)}
                >
                  <Input
                    placeholder=""
                    type={`text`}
                    className={`form-control`}
                    name={`code`}
                    maxLength={50}
                    onChange={(e) =>
                      this.props.onChange("code", e.target.value)
                    }
                    value={Func.checkUndefine(PackageRate.code)}
                    disabled={disabled}
                  />
                </HMS.FormWrapperInputComponent>
            </div>

            <div className="col-md-6">
                <HMS.FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={PackageRate.description}
                  validation={validation.description}
                  labelTitle={t(`item.packageRate.description`)}
                >
                  <Input.TextArea
                    rows={2}
                    placeholder=""
                    type={`text`}
                    className="form-control"
                    name="description"
                    maxLength={200}
                    onChange={(e) =>
                      this.props.onChange("description", e.target.value)
                    }
                    value={PackageRate.description}
                    disabled={disabled}
                  />
                </HMS.FormWrapperInputComponent>
            </div>

            <div className="col-md-6">
                <HMS.FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={PackageRate.name}
                  validation={validation.name}
                  labelTitle={t(`item.packageRate.name`)}
                >
                  <Input
                    placeholder=""
                    type={`text`}
                    className={`form-control`}
                    name={`name`}
                    maxLength={150}
                    onChange={(e) =>
                      this.props.onChange("name", e.target.value)
                    }
                    value={Func.checkUndefine(PackageRate.name)}
                    disabled={disabled}
                  />
                </HMS.FormWrapperInputComponent>
            </div>

            <div className="col-md-6">
              <HMS.FormWrapperInputComponent
                labelTitle={t(`item.packageRate.order`)}
              >
                  <InputNumber
                    placeholder=""
                    className={`form-control p-0`}
                    size="large"
                    name={`order`}
                    min={0}
                    controls={false}
                    onChange={(e) =>
                      this.props.onChange("order", e)
                    }
                    value={PackageRate.order}
                    disabled={disabled}
                  />
                </HMS.FormWrapperInputComponent>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 row">
              <div className="col-md-12">
                <PackageRateConfigTime
                  title={t(`item.packageRate.configProductSalesTime`)}
                  fieldName={"bookingDatesConfig"}
                  configTimeData={PackageRate?.bookingDatesConfig || []}
                  validation={validation}
                  t={t}
                  removeStage={this.removeStage}
                  addStage={this.addStage}
                  onSelectDateRange={this.onSelectDateRange}
                  onChange={this.props.onChange}
                  disabled={disabled}
                />
              </div>
            </div>
            <div className="col-md-6 row">
              <div className="col-md-12">
                <PackageRateConfigTime
                  isConfigProductSalesTime={true}
                  title={t(`item.packageRate.configTimeUsingProduct`)}
                  fieldName={"stayingDatesConfig"}
                  configTimeData={PackageRate?.stayingDatesConfig || []}
                  validation={validation}
                  t={t}
                  removeStage={this.removeStage}
                  addStage={this.addStage}
                  onSelectDateRange={this.onSelectDateRange}
                  onChange={this.props.onChange}
                  disabled={disabled}
                />
              </div>
            </div>
          </div>

          <div className="row mt-4 mb-4 pt-1">
            <div className="col-md-6 row">
              <div className="col-md-12">
                <div className="bpr-section">
                  <span className="bpr-headder">
                    {t("item.packageRate.advancedSearchTerms")}
                  </span>

                  <div className="row align-items-center">
                    <div className="col-md-6 px-4">
                      {t(`item.packageRate.searchByNight`)}
                    </div>

                    <div className="col-md-6">
                      <Wrapper className="d-flex">
                        <HMS.FormWrapperInputComponent
                          labelTitle={t(`item.packageRate.min`)}
                          typeInput={true}
                          classLabel="p-0 mr-2"
                          classInputForm="col p-0 mr-5"
                          className="m-0"
                        >
                          <InputNumber
                            placeholder=""
                            className={`form-control p-0`}
                            name={`minRoomNight`}
                            min={0}
                            max={
                              PackageRate.maxRoomNight != null
                                ? PackageRate.maxRoomNight
                                : Number.MAX_VALUE
                            }
                            controls={false}
                            onChange={(e) =>
                              this.props.onChange("minRoomNight", e)
                            }
                            value={PackageRate.minRoomNight}
                            disabled={disabled}
                          />
                        </HMS.FormWrapperInputComponent>

                        <HMS.FormWrapperInputComponent
                          labelTitle={t(`item.packageRate.max`)}
                          typeInput={true}
                          classLabel="p-0 mr-2"
                          classInputForm="col p-0 mr-4"
                          className="m-0"
                        >
                          <InputNumber
                            placeholder=""
                            className={`form-control p-0`}
                            name={`maxRoomNight`}
                            min={
                              PackageRate.minRoomNight != null
                                ? PackageRate.minRoomNight
                                : Number.MIN_VALUE
                            }
                            controls={false}
                            onChange={(e) =>
                              this.props.onChange("maxRoomNight", e)
                            }
                            value={PackageRate.maxRoomNight}
                            disabled={disabled}
                          />
                        </HMS.FormWrapperInputComponent>
                      </Wrapper>
                    </div>
                  </div>

                  <div className="row align-items-center mt-2">
                    <div className="col-md-6 px-4">
                      {t(`item.packageRate.searchByRoom`)}
                    </div>

                    <div className="col-md-6">
                      <Wrapper className="d-flex">
                        <HMS.FormWrapperInputComponent
                          labelTitle={t(`item.packageRate.min`)}
                          typeInput={true}
                          classLabel="p-0 mr-2"
                          classInputForm="col p-0 mr-5"
                          className="m-0"
                        >
                          <InputNumber
                            placeholder=""
                            className={`form-control p-0`}
                            name={`minRoomNumber`}
                            min={0}
                            max={PackageRate.maxRoomNumber}
                            controls={false}
                            onChange={(e) =>
                              this.props.onChange("minRoomNumber", e)
                            }
                            value={PackageRate.minRoomNumber}
                            disabled={disabled}
                          />
                        </HMS.FormWrapperInputComponent>

                        <HMS.FormWrapperInputComponent
                          labelTitle={t(`item.packageRate.max`)}
                          typeInput={true}
                          classLabel="p-0 mr-2"
                          classInputForm="col p-0 mr-4"
                          className="m-0"
                        >
                          <InputNumber
                            placeholder=""
                            type={`text`}
                            className={`form-control p-0`}
                            name={`maxRoomNumber`}
                            min={PackageRate.minRoomNumber}
                            controls={false}
                            onChange={(e) =>
                              this.props.onChange("maxRoomNumber", e)
                            }
                            value={PackageRate.maxRoomNumber}
                            disabled={disabled}
                          />
                        </HMS.FormWrapperInputComponent>
                      </Wrapper>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 row">
              <div className="col-md-12">
                <div className="bpr-section">
                  <span className="bpr-headder">
                    {t("item.packageRate.advancedApplicableConditions")}
                  </span>

                  <Wrapper className="d-flex flex-column px-2">
                    <HMS.FormWrapperInputComponent
                      isRequired={true}
                      isValidation={true}
                      dataValidation={PackageRate.channel}
                      validation={validation.channel}
                      labelTitle={t(`item.packageRate.applicablePlatform`)}
                    >
                      <div className="d-flex justify-content-between flex-column flex-lg-row">
                        <div className="ml-3">
                          <CheckboxGroup
                            className="ml-3 d-block chk-all-link"
                            options={this.getPlatformAll()}
                            value={PackageRate.channel}
                            onChange={(values) =>
                              this.props.onChange("channel", values)
                            }
                            disabled={disabled}
                          />
                        </div>

                        <div className="ml-3 mt-3 mt-lg-0">
                          <CheckboxGroup
                            className="ml-3 d-block"
                            options={this.getPlatformOther()}
                            value={PackageRate.channel}
                            onChange={(values) =>
                              this.props.onChange("channel", values)
                            }
                            disabled={disabled}
                          />
                        </div>
                      </div>
                    </HMS.FormWrapperInputComponent>

                    <HMS.FormWrapperInputComponent
                      isRequired={true}
                      isValidation={true}
                      dataValidation={PackageRate.objectApplyValue}
                      validation={validation.objectApplyValue}
                      labelTitle={t(`item.packageRate.applicableObject`)}
                    >
                      <div className="d-flex justify-content-between flex-column flex-lg-row">
                        <div className="ml-3">
                          <CheckboxGroup
                            className="ml-3 d-block chk-all-link"
                            options={this.getObjectAll()}
                            value={PackageRate.objectApplyValue}
                            onChange={(values) =>
                              this.props.onChange("objectApplyValue", values)
                            }
                            disabled={disabled}
                          />
                        </div>

                        <div className="ml-3 mt-3 mt-lg-0">
                          <CheckboxGroup
                            className="ml-3 d-block"
                            options={this.getObjectOther()}
                            value={PackageRate.objectApplyValue}
                            onChange={(values) =>
                              this.props.onChange("objectApplyValue", values)
                            }
                            disabled={disabled}
                          />
                        </div>
                      </div>
                    </HMS.FormWrapperInputComponent>
                  </Wrapper>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4 mb-4 pt-1">
            <div className="col-md-6 row">
              <div className="col-md-12">
                <div className="bpr-section">
                  <HMS.FormWrapperInputComponent
                    isRequired={false}
                    isValidation={true}
                    dataValidation={PackageRate.displaySale}
                    validation={validation.displaySale}
                    className="bpr-headder m-0"
                    labelTitle={
                      <span>
                        {t("item.packageRate.displaySale")}
                        <label className="fs15">
                          <span className="colorRed mr-1">*</span>
                        </label>
                      </span>
                    }
                  ></HMS.FormWrapperInputComponent>

                  <Wrapper className="d-flex flex-column px-2">
                    <div className="mt-3 mt-lg-0">
                      <CheckboxGroup
                        className="d-flex flex-column"
                        options={this.getDisplayType()}
                        value={PackageRate.displaySale}
                        onChange={(values) =>
                          this.props.onChange("displaySale", values)
                        }
                        disabled={disabled}
                      />
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
